import React, { useState } from 'react';
import { removeCrmLeadExternalId } from '../config/api';

const EXTERNAL_ID_LABELS = {
  pmsg_vendor_id: 'PMSG vendor ID',
  oms_user_id: 'Account',
  gst: 'GST',
};

const CrmUnlinkIdDialog = ({ leadId, externalId, onClose, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const label = EXTERNAL_ID_LABELS[externalId.type] || externalId.type;
  const displayValue = externalId.type === 'oms_user_id'
    ? externalId.omsAccount
      ? [externalId.omsAccount.name, externalId.omsAccount.phone].filter(Boolean).join(' · ')
      : `Unavailable account (#${externalId.value})`
    : externalId.value;

  const unlink = async () => {
    setSaving(true);
    setError('');
    try {
      await removeCrmLeadExternalId(leadId, externalId.id);
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setError(err.message || 'Could not unlink the identifier.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '480px' }}>
        <div className="modal-header">
          <h3>Unlink identifier</h3>
          <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <p>Remove <strong>{label}: {displayValue}</strong> from this Lead?</p>
          <p className="crm-muted">
            Source records will not be deleted. Data associated through this identifier will stop appearing on this Lead.
          </p>
          {error && <div className="crm-form-error">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className="btn btn-danger" onClick={unlink} disabled={saving}>
            {saving ? 'Unlinking…' : 'Unlink'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmUnlinkIdDialog;
